import React from 'react';

interface Props {
    examples: string[];
    onChange: (vals: string[]) => void;
    disabled: boolean;
}

export const ExamplesField = ({ examples, onChange, disabled }: Props) => (
    <div className="mt-6 mb-6">
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-eq-grey'}`}>Add Examples</h4>
        <p className={`text-sm mb-4 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            Provide example questions to show users how your assistant should be used.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {examples.map((ex, i) => (
                <input
                    key={i}
                    type="text"
                    className="mt-1 block w-full rounded-md p-3 border border-gray-400 focus:border-eq-green focus:ring-eq-green"
                    placeholder={`Example question ${i + 1}…`}
                    value={ex}
                    onChange={e => {
                        const next = [...examples];
                        next[i] = e.target.value;
                        onChange(next);
                    }}
                    disabled={disabled}
                />
            ))}
        </div>
    </div>
);
